export class CategoryNotFoundError extends Error {}
